import React, {FC} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import routes from "routes";
import { AdminFullPageLayout } from "layouts/AdminFullPageLayout/AdminFullPageLayout";

const Dashboard = React.lazy(() => import("pages/Admin/Dashboard/Dashboard"));
const Logs = React.lazy(() => import("pages/Admin/Logs/Logs"));
const Workers = React.lazy(() => import("pages/Admin/Workers/Workers"));
const Users = React.lazy(() => import("pages/Admin/Users/Users"));
const Cases = React.lazy(() => import("pages/Admin/Cases/Cases"));
const PrivacyPolicy = React.lazy(() => import("pages/Admin/PrivacyPolicy/PrivacyPolicy"));
const Settings = React.lazy(() => import("pages/Admin/Settings/Settings"));
const TermsOfUse = React.lazy(() => import("pages/Admin/TermsOfUse/TermsOfUse"));

export const Admin: FC = () => (
  <Routes>
    <Route element={<AdminFullPageLayout />}>
      <Route path={routes.admin.main} element={<Dashboard />} />
      <Route path={routes.admin.logs} element={<Logs />} />
      <Route path={routes.admin.workers} element={<Workers />} />
      <Route path={routes.admin.users} element={<Users />} />
      <Route path={routes.admin.cases} element={<Cases />} />
      <Route path={routes.admin.privacyPolicy} element={<PrivacyPolicy />} />
      <Route path={routes.admin.settings} element={<Settings />} />
      <Route path={routes.admin.termsOfUse} element={<TermsOfUse />} />
    </Route>
    <Route index element={<Navigate to={routes.admin.main} />} />
  </Routes>
);
